import React, { Component } from "react";
import Header from "../layout/Header";
import Banner from "../Common/Banner";

export default class MPTProgramme extends Component {
  render() {
    return (
      <div className="body_wrapper">
        <Header />
        <Banner title="Programme" image="banners/Programme.jpg" />

        {/* Main Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl paddingtop-2">
            <div className="ttm-service-single-content-area">
              <div className="ttm-service-description">
                {/* Courses Offered */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  {/* <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">Courses Offered</h4>
                  </div> */}
                </div>

                <div className="ttm-service-description">
                  <ul className="ttm-list ttm-list-style-icon">
                    <li>
                      <i className="fa fa-graduation-cap ttm-textcolor-skincolor"></i>
                      <strong>Master of Physiotherapy (MPT)</strong> – 2 years
                    </li>
                  </ul>
                </div>

                {/* MPT Programme Details */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h4 className="title">Master of Physiotherapy (MPT)</h4>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-5">
                    <div className="ttm_single_image-wrapper">
                      <div className="ttm_single_image-wrapper">
                        <img
                          className="img-fluid"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/programme/programme-1.jpg"
                          }
                          alt="single-img-eighteen"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 justify" style={{ margin: "auto" }}>
                    <p className="about-para">
                      The Master Degree in Physiotherapy is a{" "}
                      <strong>two-year post-graduate program</strong> where
                      students can choose their specialities based on their
                      areas of interest.
                    </p>
                    <p className="about-para">
                      This programme consists of{" "}
                      <strong>
                        classroom teaching, self-academic activities, and
                        clinical postings
                      </strong>
                      . Students are posted in their areas of clinical expertise
                      during this period.
                    </p>
                    <p className="about-para">
                      The learning program includes{" "}
                      <strong>
                        seminars, journal reviews, case presentations, case
                        discussions, and classroom teaching
                      </strong>
                      . Students are encouraged to attend conferences and
                      workshops to enhance their knowledge.
                    </p>
                  </div>
                </div>

                {/* Specialities at KHIPT */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h5 className="title">
                      MPT Specialities Available at KHIPT
                    </h5>
                  </div>
                </div>

                <div className="ttm-service-description">
                  <div className="row">
                    {[
                      "Musculo-skeletal Sciences (MPT-MSK)",
                      "Sports Sciences (MPT-Sports)",
                      "Cardio-vascular & Pulmonary Sciences (MPT-CVP)",
                      "Pediatrics (MPT-Ped)",
                      "Neurological Sciences (MPT-Neuro)",
                    ].map((spec, idx) => (
                      <div className="col-md-6" key={idx}>
                        <p className="tab-desc">
                          <i className="fa fa-check-circle ttm-textcolor-skincolor"></i>{" "}
                          {spec}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Professional Competencies */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h5 className="title">
                      Professional Competencies Developed
                    </h5>
                  </div>
                </div>

                <div className="ttm-service-description justify">
                  <p className="tab-desc">
                    A specialist physiotherapist possesses{" "}
                    <strong>advanced evaluation and assessment skills</strong>,
                    enabling the application of sound clinical reasoning to
                    diagnose and manage complex physical conditions arising from
                    dysfunction, trauma, or disease, based upon extensive
                    professional knowledge and expertise.
                  </p>
                </div>

                {/* Eligibility */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h5 className="title">Eligibility Criteria</h5>
                  </div>
                </div>

                <div className="ttm-service-description justify">
                  <p className="tab-desc">
                    <strong>B.P.T. or B.P.Th</strong> from a recognized
                    university.
                  </p>
                </div>

                {/* Fee Structure */}
                <div className="section-title with-desc text-left clearfix paddingtop-2">
                  <div
                    className="title-header"
                    style={{ borderTopColor: "red" }}
                  >
                    <h5 className="title">MPT Course Fee Structure</h5>
                  </div>
                </div>

                <div className="ttm-service-description justify">
                  <p className="tab-desc">
                    It may range from{" "}
                    <strong>
                      It may range from 1.75 lac to 2.75 lac per annum
                    </strong>{" "}
                    based on the speciality and clinical settings
                  </p>
                  <br />
                  <a
                    href="/downloads/MPT-Course-Structure.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-bgcolor-skincolor"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    Download Course Structure PDF
                  </a>
                </div>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
